import { QUERY_ORGANIZATION } from "./queries"
import { GQL } from "./GQL"
// @ts-ignore
// import getOrganizationResponse from "../fixtures/getOrganizationResponse.json"
// import getOrganizationResponse from "../fixtures/getOrganizationResponseNew.json"

export function getOrganization(id: string) {
  // @ts-ignore
  // return (getOrganizationResponse as unknown) as GetOrganizationResponse
  return GQL.request<GetOrganizationResponse>(QUERY_ORGANIZATION, { id })
}
